export const utils = {
	methods: {
		copyToClipboard (element: HTMLElement, text: string) {
			// https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript

			if (!text) return

			var textArea = document.createElement("textarea")
			textArea.value = text
			textArea.style.top = "0"
			textArea.style.left = "0"
			textArea.style.position = "fixed"

			element.appendChild(textArea)
			textArea.focus()
			textArea.select()

			document.execCommand("copy")

			element.removeChild(textArea)
		}
	}
}
